import React, { Component } from "react";
import ReactTable from "react-table";
import axios from 'axios';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Configurations } from '../../Utils/Configurations';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';

class CampaignsList extends Component {
    constructor(props) {
        super(props);

        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.carregaListaCampanhas = this.carregaListaCampanhas.bind(this);
        this.refreshTableCampanhas = this.refreshTableCampanhas.bind(this);
        this.abreDetalhes = this.abreDetalhes.bind(this);
        this.fechaDetalhes = this.fechaDetalhes.bind(this);
        this.copiarCampanha = this.copiarCampanha.bind(this);
        this.editarRascunho = this.editarRascunho.bind(this);
        this.enviarRascunho = this.enviarRascunho.bind(this);
        this.abrirConfirmaExclusao = this.abrirConfirmaExclusao.bind(this);
        this.fecharConfirmaExclusao = this.fecharConfirmaExclusao.bind(this);
        this.confirmarExclusao = this.confirmarExclusao.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            hasError: false,
            errorMessage: '',
            listaCampanhas: [],
            paginasCampanhas: 1,
            limite: 15,
            pagina: 0,
            isLoadingCampanhas: false,
            modalDetalhes: false,
            isLoadingDetalhes: false,
            campanhaDetalhe: null,
            isEnviandoRascunho: false,
            modalConfirmaExclusao: false,
            isExcluindo: false,
        }

        this.columns = [
            {
                Header: 'id',
                accessor: 'idCampanha',
                className: 'text-center pointer',
                width: 70
            },
            {
                Header: 'Título',
                accessor: 'titulo',
                className: 'text-left pointer',
            },
            {
                Header: 'Público-alvo',
                className: 'text-center pointer',
                width: 220,
                Cell: row => <span>{this.publicoLabel(row.original.segmentacao)}</span>
            },
            {
                Header: 'Status',
                accessor: 'status',
                className: 'text-center pointer',
                width: 130,
                Cell: row => (
                    <span className={`badge badge-${this.statusBadge(row.value)}`}>{this.statusLabel(row.value)}</span>
                )
            },
            {
                Header: 'Sucesso / Erro',
                className: 'text-center pointer',
                width: 130,
                Cell: row => <span>{row.original.totalSucesso} / {row.original.totalErro}</span>
            },
            {
                Header: 'Cliques',
                accessor: 'totalCliques',
                className: 'text-center pointer',
                width: 90
            },
            {
                Header: 'Criado por',
                accessor: 'criadoPor',
                className: 'text-center pointer',
                width: 160
            },
            {
                Header: 'Data de criação',
                accessor: 'dtCriacao',
                className: 'text-center pointer',
                width: 160,
                // Datas vêm do banco em UTC — convertidas explicitamente pro fuso de São Paulo
                // em vez de depender do fuso local do navegador de quem acessa o painel.
                Cell: row => (row.value ? <span>{moment.utc(row.value).tz('America/Sao_Paulo').format("DD/MM/YY HH:mm")}</span> : <span>-</span>)
            },
            {
                Header: 'Data de envio',
                accessor: 'dtEnvio',
                className: 'text-center pointer',
                width: 160,
                Cell: row => (row.value ? <span>{moment.utc(row.value).tz('America/Sao_Paulo').format("DD/MM/YY HH:mm")}</span> : <span>-</span>)
            },
            {
                Header: 'Agendado para',
                accessor: 'dtAgendamento',
                className: 'text-center pointer',
                width: 160,
                Cell: row => (row.value ? <span>{moment.utc(row.value).tz('America/Sao_Paulo').format("DD/MM/YY HH:mm")}</span> : <span>-</span>)
            },
        ]
    }

    handleError(err) {
        const message = (err.response && err.response.data && err.response.data.message) || err.message;
        this.setState({ hasError: true, errorMessage: message })
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    publicoLabel(segmentacao) {
        if (!segmentacao) return '-';
        switch (segmentacao.tipo) {
            case 'todos': return 'Todos os usuários';
            case 'plataforma': return `Plataforma: ${segmentacao.valor === 'android' ? 'Android' : 'iOS'}`;
            case 'topico': return `Tópico: ${segmentacao.valor}`;
            case 'tokens': return `Tokens específicos (${segmentacao.qtdTokens || 0})`;
            default: return '-';
        }
    }

    statusBadge(status) {
        switch (status) {
            case 'rascunho': return 'secondary';
            case 'agendada': return 'info';
            case 'enviado': return 'success';
            case 'parcial': return 'warning';
            case 'erro': return 'danger';
            default: return 'secondary';
        }
    }

    statusLabel(status) {
        switch (status) {
            case 'rascunho': return 'Rascunho';
            case 'agendada': return 'Agendada';
            case 'enviado': return 'Enviado';
            case 'parcial': return 'Parcial';
            case 'erro': return 'Erro';
            default: return status;
        }
    }

    refreshTableCampanhas(o) {
        this.carregaListaCampanhas(o);
    }

    carregaListaCampanhas(o) {
        this.setState({ isLoadingCampanhas: true })
        let pagina, tamanhoPagina;
        if (o === undefined) {
            pagina = 0;
            tamanhoPagina = this.state.limite;
        } else if (!o.pageSize) {
            tamanhoPagina = this.state.limite;
            pagina = this.state.pagina;
        } else {
            tamanhoPagina = o.pageSize;
            pagina = o.page;
            this.setState({ pagina, limite: tamanhoPagina })
        }

        axios.get(this.Configurations.apiBasePath + `/campanhas-push?page=${pagina + 1}&pageSize=${tamanhoPagina}`)
            .then(response => {
                this.setState({
                    listaCampanhas: response.data.dados,
                    paginasCampanhas: response.data.paginacao.totalPaginas,
                });
            }).catch(this.handleError).finally(() => this.setState({ isLoadingCampanhas: false }));
    }

    abreDetalhes(idCampanha) {
        this.setState({ modalDetalhes: true, isLoadingDetalhes: true, campanhaDetalhe: null });
        axios.get(this.Configurations.apiBasePath + `/campanhas-push/${idCampanha}`)
            .then(response => {
                this.setState({ campanhaDetalhe: response.data.dados });
            }).catch(this.handleError).finally(() => this.setState({ isLoadingDetalhes: false }));
    }

    fechaDetalhes() {
        this.setState({ modalDetalhes: false, campanhaDetalhe: null });
    }

    copiarCampanha() {
        const { campanhaDetalhe } = this.state;
        if (!campanhaDetalhe) return;

        this.props.history.push({ pathname: '/campanhas/nova', state: { campanhaParaCopiar: campanhaDetalhe } });
    }

    editarRascunho() {
        const { campanhaDetalhe } = this.state;
        if (!campanhaDetalhe) return;

        this.props.history.push({ pathname: '/campanhas/nova', state: { campanhaParaEditar: campanhaDetalhe } });
    }

    abrirConfirmaExclusao() {
        this.setState({ modalConfirmaExclusao: true });
    }

    fecharConfirmaExclusao() {
        this.setState({ modalConfirmaExclusao: false });
    }

    confirmarExclusao() {
        const { campanhaDetalhe } = this.state;
        if (!campanhaDetalhe) return;

        this.setState({ isExcluindo: true });
        axios.delete(this.Configurations.apiBasePath + `/campanhas-push/${campanhaDetalhe.idCampanha}`)
            .then(() => {
                this.setState({ modalConfirmaExclusao: false });
                this.fechaDetalhes();
                this.refreshTableCampanhas({ page: this.state.pagina, pageSize: this.state.limite });
            })
            .catch(this.handleError)
            .finally(() => this.setState({ isExcluindo: false }));
    }

    enviarRascunho() {
        const { campanhaDetalhe } = this.state;
        if (!campanhaDetalhe) return;

        this.setState({ isEnviandoRascunho: true });
        axios.post(this.Configurations.apiBasePath + `/campanhas-push/${campanhaDetalhe.idCampanha}/enviar`)
            .then(() => {
                this.abreDetalhes(campanhaDetalhe.idCampanha);
                this.refreshTableCampanhas({ page: this.state.pagina, pageSize: this.state.limite });
            })
            .catch(this.handleError)
            .finally(() => this.setState({ isEnviandoRascunho: false }));
    }

    renderDetalhes() {
        const { campanhaDetalhe, isLoadingDetalhes } = this.state;

        if (isLoadingDetalhes) {
            return (
                <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status" />
                </div>
            );
        }

        if (!campanhaDetalhe) return null;

        return (
            <div>
                <p><strong>Título:</strong> {campanhaDetalhe.titulo}</p>
                <p><strong>Corpo:</strong> {campanhaDetalhe.corpo}</p>
                <p><strong>Público-alvo:</strong> {this.publicoLabel(campanhaDetalhe.segmentacao)}</p>
                <p><strong>Status:</strong> <span className={`badge badge-${this.statusBadge(campanhaDetalhe.status)}`}>{this.statusLabel(campanhaDetalhe.status)}</span></p>
                {campanhaDetalhe.status === 'agendada' && campanhaDetalhe.dtAgendamento && (
                    <p><strong>Agendada para:</strong> {moment.utc(campanhaDetalhe.dtAgendamento).tz('America/Sao_Paulo').format("DD/MM/YYYY [às] HH:mm")}</p>
                )}
                <p><strong>Sucesso / Erro:</strong> {campanhaDetalhe.totalSucesso} / {campanhaDetalhe.totalErro}</p>
                <p><strong>Cliques:</strong> {campanhaDetalhe.totalCliques || 0}</p>
                {campanhaDetalhe.mensagemErro && <p className="text-danger"><strong>Mensagem de erro:</strong> {campanhaDetalhe.mensagemErro}</p>}
                {campanhaDetalhe.parametros && Object.keys(campanhaDetalhe.parametros).length > 0 && (
                    <div>
                        <strong>Parâmetros customizados:</strong>
                        <ul className="mb-0">
                            {Object.entries(campanhaDetalhe.parametros).map(([chave, valor]) => (
                                <li key={chave}>{chave}: {valor}</li>
                            ))}
                        </ul>
                    </div>
                )}
                {campanhaDetalhe.segmentacao.tokens && (
                    <div className="mt-2">
                        <strong>Tokens ({campanhaDetalhe.segmentacao.tokens.length}):</strong>
                        <div className="small text-break" style={{ maxHeight: 150, overflowY: 'auto' }}>
                            {campanhaDetalhe.segmentacao.tokens.join(', ')}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    render() {
        return (
            <div className="row campaigns-list">
                <div className="col-12">
                    <div className="row no-gutters text-left align-items-center">
                        <div className="col-12 col-lg-8">
                            <h2>Campanhas - Histórico de disparos</h2>
                        </div>
                        <div className="col-12 col-lg-4 text-lg-right">
                            <Link to="/campanhas/nova" className="btn btn-primary">+ Nova campanha</Link>
                        </div>
                    </div>
                </div>
                <div className="col-12 text-center text-lg-left">
                    <p className="py-2 m-0">Clique em uma campanha para ver os detalhes do disparo.</p>
                    <div className="card">
                        <div className="card-body p-0">
                            <ReactTable
                                data={this.state.listaCampanhas}
                                columns={this.columns}
                                onFetchData={this.refreshTableCampanhas}
                                defaultPageSize={10}
                                pages={this.state.paginasCampanhas}
                                page={this.state.pagina}
                                manual
                                pageSize={this.state.limite}
                                loading={this.state.isLoadingCampanhas}
                                className="-striped -highlight"
                                headerClassName="ebs-table-header"
                                previousText='Anterior'
                                nextText='Próximo'
                                loadingText='Carregando...'
                                noDataText='Nenhuma campanha encontrada.'
                                pageText='Página'
                                ofText='de'
                                rowsText='linhas'
                                getTdProps={(state, rowInfo) => ({
                                    onClick: () => {
                                        if (rowInfo) this.abreDetalhes(rowInfo.original.idCampanha);
                                    }
                                })}
                            />
                        </div>
                    </div>
                </div>

                <Modal isOpen={this.state.modalDetalhes} toggle={this.fechaDetalhes}>
                    <ModalHeader toggle={this.fechaDetalhes}>Detalhes da campanha</ModalHeader>
                    <ModalBody>
                        {this.renderDetalhes()}
                    </ModalBody>
                    <ModalFooter>
                        {this.state.campanhaDetalhe && ['rascunho', 'agendada'].includes(this.state.campanhaDetalhe.status) && (
                            <>
                                <Button color="danger" outline onClick={this.abrirConfirmaExclusao}>
                                    Excluir
                                </Button>
                                <Button color="secondary" outline onClick={this.editarRascunho}>
                                    {this.state.campanhaDetalhe.status === 'agendada' ? 'Editar agendamento' : 'Editar rascunho'}
                                </Button>
                                <Button color="success" onClick={this.enviarRascunho} disabled={this.state.isEnviandoRascunho}>
                                    {this.state.isEnviandoRascunho ? 'Enviando...' : 'Enviar campanha agora'}
                                </Button>
                            </>
                        )}
                        <Button color="primary" outline onClick={this.copiarCampanha} disabled={!this.state.campanhaDetalhe}>
                            Copiar para nova campanha
                        </Button>
                        <Button color="secondary" onClick={this.fechaDetalhes}>fechar</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalConfirmaExclusao} toggle={this.fecharConfirmaExclusao}>
                    <ModalHeader toggle={this.fecharConfirmaExclusao}>Excluir campanha</ModalHeader>
                    <ModalBody>
                        Tem certeza que deseja excluir este rascunho/agendamento de campanha? Essa ação não pode ser desfeita.
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={this.confirmarExclusao} disabled={this.state.isExcluindo}>
                            {this.state.isExcluindo ? 'Excluindo...' : 'Excluir'}
                        </Button>
                        <Button color="secondary" onClick={this.fecharConfirmaExclusao} disabled={this.state.isExcluindo}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>
        )
    }
}

export default CampaignsList;
